import workoutsLight from 'images/year-in-review/2017/icons/community-workouts-light.png'
import workoutsGradient from 'images/year-in-review/2017/icons/community-workouts-gradient.png'
import energyLight from 'images/year-in-review/2017/icons/community-energy-light.png'
import energyGradient from 'images/year-in-review/2017/icons/community-energy-gradient.png'
import durationGradient from 'images/year-in-review/2017/icons/community-duration.png'
import distanceGradient from 'images/year-in-review/2017/icons/community-distance.png'
import routesGradient from 'images/year-in-review/2017/icons/community-routes.png'

const icons = {
  durationGradient,
  distanceGradient,
  workoutsLight,
  workoutsGradient,
  energyLight,
  energyGradient,
  routesGradient,
}
export default icons



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Community/communityIcons.js